import { inject, InjectionToken, PLATFORM_ID } from '@angular/core';
import { Observable } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';
import { fromEvent, of } from 'rxjs';

export const WINDOW = new InjectionToken<Window>('window', {
  providedIn: 'root',
  factory: () => (typeof window !== 'undefined' ? window : undefined) as unknown as Window,
});

export const SCROLL_OBSERVER = new InjectionToken<Observable<Event | null>>('global event scroll', {
  providedIn: 'root',
  factory: () => {
    const window = inject(WINDOW);
    const platformId = inject(PLATFORM_ID);

    if (!isPlatformBrowser(platformId)) {
      return of(null);
    }

    return fromEvent(window, 'scroll');
  },
});
